
import {computed, defineComponent} from "vue";
import { useStore } from "vuex";
import {key} from "@/store";
import TemporizadorVue from "@/components/TemporizadorVue.vue";


export default defineComponent({
  name: 'FormularioVue',
  emits: ['aoSalvarTarefa'],
  data() {
    return {
      descricao: '',
      idProjeto: '',
    }
  },
  components: {
    TemporizadorVue
  },
  methods: {
    finalizarTarefa(tempoDecorrido: number): void {
      this.$emit('aoSalvarTarefa', {
        duracaoEmSegundos: tempoDecorrido,
        descricao: this.descricao,
        projeto: this.projetos.find((proj: { id: string; }) => proj.id == this.idProjeto)
      });
      this.descricao = '';
    },
  },
  setup () {
    const store = useStore(key);
    return {
        projetos: computed(() => store.state.projetos)
    }
  }
});
